import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppUser } from "../../modules/shared/app-user";
import { AuthActions } from "../../auth/store/actions";
import { ActivatedRoute } from "@angular/router";
import { Strings } from "../../../strings/strings";
import { AccountConfigurationAuth0Minimal } from "@hydrantid/acm-client";
import { CachedDataService } from "../../services/cached-data/cached-data.service";
import { firstValueFrom } from "rxjs";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    standalone: false,
})
export class LoginComponent {
    strings = Strings;
    connectionInfo: AccountConfigurationAuth0Minimal = {
        name: "your account",
        connection: "default",
    };

    constructor(
        private activatedRoute: ActivatedRoute,
        private globalStore: Store<{ appUser: AppUser }>,
        private cachedDataService: CachedDataService,
    ) {
        this.startLogin();
    }

    async startLogin(): Promise<void> {
        const params = await firstValueFrom(this.activatedRoute.params);
        const queryParams = await firstValueFrom(this.activatedRoute.queryParams);
        const email = queryParams.email;
        this.connectionInfo = await firstValueFrom(this.cachedDataService.getConnectionInfoForSlug(params.connection));
        this.globalStore.dispatch(AuthActions.login({ connection: this.connectionInfo.connection, email }));
    }
}
